module.exports = __webpack_public_path__ + "static/media/excel.60637375.jpg";